import Backend from 'App/Dataman-Backend';

const { apiUrlResearches, apiUrlResearchesDomains, apiUrlResearchesCategories, apiUrlResearchesAuthors, apiUrlSuffix } =
  Backend.config;

export const RESEARCHES_PATHS = {
  researches: apiUrlResearches,
  domains: apiUrlResearchesDomains,
  categories: apiUrlResearchesCategories,
  authors: apiUrlResearchesAuthors,
  suffix: apiUrlSuffix,
};
